const STORAGE_KEY = 'jbl_referral_code';

/**
 * Capture referral from the URL and persist for the session.
 * PIBOOST (etc.) should link: /qualify?ref=piboost_fb
 * Also accepts utm_source when it matches a known-style code.
 */
export function captureReferralFromUrl(search = window.location.search) {
  try {
    const params = new URLSearchParams(search);
    const raw = params.get('ref') || params.get('referral') || params.get('utm_source') || '';
    const code = normalizeReferralCode(raw);
    if (code) {
      sessionStorage.setItem(STORAGE_KEY, code);
      return code;
    }
  } catch {
    // ignore
  }
  return getStoredReferralCode();
}

export function getStoredReferralCode() {
  try {
    return normalizeReferralCode(sessionStorage.getItem(STORAGE_KEY) || '') || 'organic';
  } catch {
    return 'organic';
  }
}

export function normalizeReferralCode(raw) {
  if (!raw || typeof raw !== 'string') return '';
  return raw
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, '_')
    .replace(/[^a-z0-9_]/g, '')
    .slice(0, 64);
}
